import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, Phone } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export const NotFound = () => {
  useEffect(() => {
    document.title = 'Page introuvable | NETTO+';
    // Les moteurs ne doivent pas indexer une page d'erreur.
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 pt-32 pb-24">
        <div className="text-center max-w-md">
          <p className="text-7xl font-bold text-blue-600 mb-4">404</p>
          <h1 className="text-2xl font-bold text-gray-900 mb-3">Cette page n'existe pas</h1>
          <p className="text-gray-600 mb-8">
            Le lien est peut-être erroné ou la page a été déplacée.
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
            >
              <Home className="w-4 h-4" aria-hidden="true" />
              Retour à l'accueil
            </Link>
            <a
              href="/#contact"
              className="inline-flex items-center gap-2 border-2 border-gray-200 hover:border-blue-600 px-6 py-3 rounded-lg font-semibold text-gray-900 transition-colors"
            >
              <Phone className="w-4 h-4" aria-hidden="true" />
              Nous contacter
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
